import { Component, ChangeDetectionStrategy, inject } from '@angular/core';

import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { UtilsService } from 'src/app/services/utils.service';
import { ApiService } from 'src/app/services/api.service';
import { DocumentRelatedType, DocumentRelatedTypeLabels } from 'src/app/enums/document-related-type.enum';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-create-document-type-dialog',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatSelectModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    CdkScrollable,
  ],
  templateUrl: './create-document-type-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./create-document-type-dialog.component.css'],
})
export class CreateDocumentTypeDialogComponent {
  private fb = inject(FormBuilder);
  private utilsService = inject(UtilsService);
  private apiService = inject(ApiService);
  dialogRef = inject<MatDialogRef<CreateDocumentTypeDialogComponent, CreateDocumentTypeDialogResult>>(MatDialogRef);
  data = inject<CreateDocumentTypeDialogData>(MAT_DIALOG_DATA);

  form: FormGroup;

  morphOptions: { value: DocumentRelatedType; label: string }[] = Object.values(DocumentRelatedType).map(
    (value: DocumentRelatedType): { value: DocumentRelatedType; label: string } => ({
      value,
      label: DocumentRelatedTypeLabels[value],
    })
  );

  constructor() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      slug: [{ value: '', disabled: true }],
      related_type: [DocumentRelatedType.User, Validators.required],
      related_user_can_view_document: [false],
    });

    this.form.get('name')?.valueChanges.subscribe((name: string): void => {
      const slug = this.utilsService.generateSlug(name);
      this.form.get('slug')?.setValue(slug, { emitEvent: false });
    });
  }

  save(): void {
    if (!this.form.valid) return;

    const formData = { ...this.form.value };
    delete formData.slug;

    this.apiService.createDocumentType(formData).subscribe({
      next: () => {
        this.dialogRef.close({ success: true });
      },
    });
  }

  cancel(): void {
    this.dialogRef.close();
  }
}

interface CreateDocumentTypeDialogData {
  mode: 'create';
}

interface CreateDocumentTypeDialogResult {
  success?: boolean;
}
